export default {
    path: '/setting',
    meta: {
        title: '个人资料',
    },
    component: r => require.ensure([], () => r(require(`./index.vue`)), `/setting`),
}


// WEBPACK FOOTER //
// ./src/views/Setting/router.js